import type Highcharts from "highcharts";

export default function forceStartEndTicks(H: typeof Highcharts) {
  H.wrap(H.Axis.prototype, "trimTicks", function (
    this: Highcharts.Axis,
    proceed: {
      apply: (arg0: Highcharts.Axis, arg1: [number[], boolean, boolean]) => void;
    },
    ...args: [number[], boolean, boolean]
  ) {
    proceed.apply(this, [
      args[0],
      this.userOptions.startOnTick || false,
      this.userOptions.endOnTick || false,
    ]);
  } as Highcharts.WrapProceedFunction);
}
